import integrationLinks from './integrationsLinks';
import cockpit from './cockpit';

const targetDefault = '_blank';

const redirectTolink = async (linkBase, target) => {
	let token = cockpit.getToken();
	if (cockpit.isRefreshable()) {
		token = await cockpit.getRefreshedToken();
	}
	const siteLink = linkBase + token;
	window.open(siteLink, target);
};

export const redirectToSites = (target = targetDefault) => {
	redirectTolink(integrationLinks.sites, target);
};

export const redirectToChamados = (target = targetDefault) => {
	redirectTolink(integrationLinks.chamados, target);
};

const loggedRedirecTo = {
	sites: redirectToSites,
	chamados: redirectToChamados,
};

export default loggedRedirecTo;
